// @flow
import { connect } from 'react-redux';

import CardBackground from 'components/fragments/card/CardBackground';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/fragments/card/CardBackground';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  })
)(CardBackground);
